// src/admin/views/OrganizationView.js
import { useNavigate } from 'react-router-dom'
import '../../styles/admin.css'
import PageHeader from '../components/PageHeader'

function OrganizationView({
  organizationData,
  handleChange,
  handleSubmit,
}) {
  const navigate = useNavigate()

  return (
    <>
      <PageHeader pageName={'Organization Info'} backTo="/admin/orgs" />
      <div className="admin-card-container">
        <div className="admin-card">
          <form onSubmit={handleSubmit}>
            <div className="admin-input-group">
              <label htmlFor="orgName" className="admin-label">
                Organization Name
              </label>
              <input
                type="text"
                id="orgName"
                name="orgName"
                className="admin-input"
                value={organizationData.orgName}
                onChange={handleChange}
                required
                placeholder="e.g. Golfers Association"
              />
            </div>

            <div className="admin-button-group">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/admin/orgs')}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Organization
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default OrganizationView
